<template>
  <div :class="containerClasses">
    <b-dropdown variant="outline-secondary" :right="floatLeft" toggle-class="filter-multi" :class="classes">
      <template slot="button-content" >
        {{ $t("core.filter_by") }} {{ title }}
      </template>
      <b-dropdown-text>
        <b-form-checkbox-group v-model="value" :options="selectItems" :value-field="valueField" :text-field="textField"
                               @change="enableFilter" stacked>
        </b-form-checkbox-group>
      </b-dropdown-text>
    </b-dropdown>
  </div>
</template>

<style type="scss">
  .filter-multi {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057 !important;
    background-color: #fff !important;
    background-clip: padding-box;
    border: 1px solid #ced4da !important;
    border-radius: 0.125rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
</style>

<script>
  import axios from 'axios'
  import qs from 'qs'

  export default {
    name: 'o-filter-checkbox',
    props: {
      title: {
        type: String,
        required: true
      },
      column: {
        type: String,
        required: false
      },
      valueField: {
        type: String,
        default: 'value'
      },
      textField: {
        type: String,
        default: 'text'
      },
      url: {
        type: String,
        default: ''
      },
      classes: {
        type: String,
        default: ''
      },
      items: {
      },
      floatLeft: {
        type: Boolean,
        default: true
      }
    },

    data: () => ({
      containerClasses: '',
      ajaxItems: [],
      value: []
    }),

    methods: {
      enableFilter() {
        this.$nextTick(() => {
          this.$parent.$emit('enable-filter', {
            column: this.column ? this.column : this.title,
            title: this.title,
            value: this.value,
            displayValue: this.value.toString()
          })
        })
      },

      checkUrlFilter() {
        // check url hash to see if we have a filter in the uri
        if (!document.location.search) {
          return
        }
        var params = qs.parse(document.location.search.substr(1))

        if (this.column in params.filter) {
          this.$parent.$emit('enable-filter', {
            column: this.column ? this.column : this.title,
            title: this.title,
            value: params.filter[this.column],
            displayValue: this.selectItems.find((item) => item[this.valueField] == params.filter[this.column])[this.textField]
          })
        }
      }
    },

    created() {
      if (this.url === '') {
        this.checkUrlFilter()
        return
      }
      axios
        .get(this.url, {params: {perPage: 0}})
        .then((response) => {
          this.ajaxItems = response.data.data
          this.checkUrlFilter()
        })
        .catch((error) => {
          console.log(error)
          window.alert('could not fetch value list options from ' + this.url)
        })
    },

    computed: {
      selectItems () {
        if (this.ajaxItems.length > 0) {
          return this.ajaxItems
        } else {
          return this.items
        }
      }
    },

    mounted() {
      this.$on('set-classes', (classes) => {
        this.containerClasses = classes
      })
      this.$root.$on('bv::dropdown::show', bvEvent => {
        //this.value = []
      })
    }
  }
</script>
<style>
  div.w260 ul {
    width: 260px !important;
  }
</style>
